function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "icons/clone");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M15.1818182,4 L6.45454545,4 C5.65454545,4 5,4.65454545 5,5.45454545 L5,15.6363636 L6.45454545,15.6363636 L6.45454545,5.45454545 L15.1818182,5.45454545 L15.1818182,4 Z M17.3636364,6.90909091 L9.36363636,6.90909091 C8.56363636,6.90909091 7.90909091,7.56363636 7.90909091,8.36363636 L7.90909091,18.5454545 C7.90909091,19.3454545 8.56363636,20 9.36363636,20 L17.3636364,20 C18.1636364,20 18.8181818,19.3454545 18.8181818,18.5454545 L18.8181818,8.36363636 C18.8181818,7.56363636 18.1636364,6.90909091 17.3636364,6.90909091 Z M17.3636364,18.5454545 L9.36363636,18.5454545 L9.36363636,8.36363636 L17.3636364,8.36363636 L17.3636364,18.5454545 Z",
  id: "path-1"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Automation",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "10---Rule-Added",
  transform: "translate(-1264.000000, -180.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "smartflow",
  transform: "translate(24.000000, 164.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "icons/clone",
  transform: "translate(1240.000000, 16.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  x: 0,
  y: 0,
  width: 24,
  height: 24
}), /*#__PURE__*/React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-1"
})), /*#__PURE__*/React.createElement("use", {
  id: "icon/content/copy_24px",
  fill: "#707070",
  fillRule: "nonzero",
  xlinkHref: "#path-1"
})))));

var SvgClone = function SvgClone(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgClone, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/clone.2d1d9887.svg";
export { ForwardRef as ReactComponent };